import React from 'react';
import { Title, Button, ButtonsGroup } from 'components/commons';
import clockIcon from 'assets/svg/speed-clock.svg';

type LoanApplicationInProgressLayoutProps = {
    onOk(): void;
}

const LoanApplicationInProgressLayout: React.FC<LoanApplicationInProgressLayoutProps> = ({ onOk }) => (
    <div className="message-box-container">
        <div className="inner">
            <div className="screen">
                <div className="message-box message-box__application-progress text-left">
                    <img className="icon clock-icon" src={clockIcon} />
                    <Title>este CNPJ já tem um pedido <br className="hidden-sm" />em andamento</Title>
                    <p className="text">Caso queira acompanhar o seu pedido de <br className="hidden-sm" />empréstimo, <a href='https://bizcapital.com.br/central-de-ajuda/por-que-recebi-a-mensagem-que-ja-existe-pedido-em-andamento/' target='_blank' >saiba mais.</a></p>
                </div>

                <ButtonsGroup align="left">
                    <Button label="concluir" onClick={onOk} />
                </ButtonsGroup>
            </div>
        </div>
    </div>
);

export default LoanApplicationInProgressLayout;
